import HttpClient from "../../utils/http";
import { landing_page_endpoint, landing_page_rules_endpoint, landing_page_rules_check_overlap_endpoint, landing_page_rules_user_count_endpoint } from "../constants/api_endpoints";

export const addLandingPage = async (payload: any) => {

    return HttpClient.post(landing_page_endpoint, payload, {
        headers: {
            'Content-Type': 'application/json'
        }
    })

}

// Edit landing page content - backend expects PATCH with content_id inside payload
export const updateLandingPage = async (contentId: number | string, payload: any) => {
  return HttpClient.patch(`${landing_page_endpoint}/${contentId}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export interface LandingPageFilters {
  page: number;
  pageSize: number;
  startDate?: string;
  endDate?: string;
  module?: string;
  sortBy?: "createdAt" | "content_name";
  sortOrder?: "ASC" | "DESC";
  orgId?: number | null;
}

export const getLandingPages = async (filters: LandingPageFilters) => {
  const { page, pageSize, startDate, endDate, module, sortBy, sortOrder, orgId } = filters;

  const params = new URLSearchParams({
    page: page.toString(),
    size: pageSize.toString(),
  });

  if (startDate) params.append("dateFrom", startDate);
  if (endDate) params.append("dateTo", endDate);
  if (module) params.append("module", module);
  if (sortBy) params.append("sortBy", sortBy);
  if (sortOrder) params.append("sortOrder", sortOrder);
  if (orgId) params.append("orgId", orgId.toString());

  const url = `${landing_page_endpoint}?${params.toString()}`;
  return HttpClient.get(url);
};

export const getLandingPageById = async (contentId: number | string) => {
  return HttpClient.get(`${landing_page_endpoint}/${contentId}`);
};

export interface SignedUrlRequest {
  fileName: string;
  bucketType: string;
  contentType: string;
  ObjectId: string;
}

export interface SignedUrlResponse {
  signedUrl?: string;
  url?: string;
  data?: {
    signedUrl?: string;
    url?: string;
  };
}

export const getSignedUrl = async (payload: SignedUrlRequest): Promise<any> => {
  return HttpClient.post("v1/admin/qsubscribers/signed-url", payload);
};

export interface TTSRequest {
  text: string;
  language: string;
}

export interface TTSResponse {
  audio?: string; // Base64 encoded audio
  data_url?: string; // Data URL format: "data:audio/wav;base64,..."
  format?: string; // Audio format (e.g., "wav", "mp3")
  language?: string; // Language code
  audioUrl?: string; // Legacy support
  data?: {
    audioUrl?: string;
    audio?: string;
    data_url?: string;
    format?: string;
  };
}

export const deleteLandingPage = async (contentId: number) => {
  return HttpClient.delete(`${landing_page_endpoint}/${contentId}`);
};

export const convertTextToSpeech = async (payload: TTSRequest): Promise<any> => {
  // Use direct fetch for localhost TTS service
  const response = await fetch("http://localhost:5001/tts/generate", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  
  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`TTS API error: ${response.statusText} - ${errorText}`);
  }
  
  // Check if response is binary audio (audio/mpeg, audio/wav, etc.)
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.startsWith("audio/")) {
    return response.blob();
  }
  
  // Otherwise, try to parse as JSON
  try {
    return await response.json();
  } catch (e) {
    // If JSON parsing fails, return as blob
    return response.blob();
  }
};

export const createOrUpdateRule = async (payload: any) => {
  // Use PATCH if payload has id (editing), otherwise POST (creating)
  if (payload.id) {
    const { id, ...patchPayload } = payload; // Remove id from payload body (it's in URL)
    return HttpClient.patch(`${landing_page_rules_endpoint}/${id}`, patchPayload, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  return HttpClient.post(landing_page_rules_endpoint, payload, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getRules = async (params?: { page?: number; size?: number }) => {
  let url = landing_page_rules_endpoint;
  if (params?.page != null || params?.size != null) {
    const search = new URLSearchParams();
    if (params.page != null) search.set("page", String(params.page));
    if (params.size != null) search.set("size", String(params.size));
    url += `?${search.toString()}`;
  }
  return HttpClient.get(url);
};

export const getRuleById = async (ruleId: number) => {
  return HttpClient.get(`${landing_page_rules_endpoint}/${ruleId}`);
};

export const deleteRule = async (ruleId: number) => {
  return HttpClient.delete(`${landing_page_rules_endpoint}/${ruleId}`);
};

export const checkRuleOverlap = async (payload: any) => {
  return HttpClient.post(landing_page_rules_check_overlap_endpoint, payload, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

export const getUserCountForRule = async (payload: any) => {
  return HttpClient.post(landing_page_rules_user_count_endpoint, payload, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};
